module.exports = __webpack_public_path__ + "img/share-coupon5.b3dbbab6.png";